import imgModernVillaFront from '../assets/images/projects/modern-villa-front.jpg';
import imgModernVillaAngle from '../assets/images/projects/modern-villa-angle.jpg';
import imgContemporaryDay from '../assets/images/projects/contemporary-residence-day.jpg';
import imgContemporaryAngle from '../assets/images/projects/contemporary-residence-angle.jpg';
import imgArabianVilla from '../assets/images/projects/arabian-villa.jpg';
import imgAmmarEvening from '../assets/images/projects/ammar-residence-evening.jpg';
import imgAmmarNight from '../assets/images/projects/ammar-residence-night.jpg';
import imgSohelHouse from '../assets/images/projects/sohel-house.jpg';
import imgCompactNight from '../assets/images/projects/compact-house-night.jpg';

const projects = [
  {
    id: 'modern-villa-residence',
    title: 'Modern Villa Residence',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgModernVillaFront,
    location: 'Anand, India',
    year: '2024',
    area: '4,500 sq ft',
    description: 'Contemporary villa featuring decorative jali screens, lush landscaping, and a bold geometric facade.',
    details: 'This modern villa residence showcases the perfect blend of contemporary architecture and traditional Indian design elements. The decorative jali screens provide privacy while allowing natural light to filter through, creating dynamic shadow patterns throughout the day. The bold geometric facade makes a striking visual statement, while the lush landscaping softens the overall composition and creates a serene living environment.',
    features: ['Decorative Jali Screens', 'Geometric Facade', 'Lush Landscaping', 'Natural Light Design', 'Open Floor Plan'],
  },
  {
    id: 'modern-villa-evening',
    title: 'Modern Villa - Evening View',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgModernVillaAngle,
    location: 'Anand, India',
    year: '2024',
    area: '4,500 sq ft',
    description: 'The same villa captured at golden hour, showcasing the interplay of warm light and modern materials.',
    details: 'As the sun sets, this villa transforms into a glowing masterpiece. The carefully planned lighting design highlights the architectural features and material textures, creating a warm and inviting atmosphere. The interplay between natural and artificial lighting showcases the depth of design thinking that went into every aspect of this residence.',
    features: ['Strategic Lighting Design', 'Material Textures', 'Warm Ambience', 'Evening Aesthetic', 'Architectural Drama'],
  },
  {
    id: 'contemporary-urban-house',
    title: 'Contemporary Urban House',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgContemporaryDay,
    location: 'Nadiad, India',
    year: '2023',
    area: '3,800 sq ft',
    description: 'A sleek three-story residence blending wood cladding, stone textures, and glass for a striking street presence.',
    details: 'This three-story contemporary residence stands as a testament to modern urban living. The thoughtful combination of wood cladding, natural stone, and expansive glass creates a dynamic facade that changes character with the light. Each floor is designed to serve a specific function while maintaining visual continuity throughout.',
    features: ['Wood Cladding', 'Stone Textures', 'Expansive Glass', 'Three-Story Design', 'Urban Integration'],
  },
  {
    id: 'arabian-heritage-villa',
    title: 'Arabian Heritage Villa',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgArabianVilla,
    location: 'Nadiad, India',
    year: '2023',
    area: '5,200 sq ft',
    description: 'An elegant villa inspired by Islamic architectural traditions with ornate arched jali patterns and warm desert tones.',
    details: 'Drawing deep inspiration from Islamic architectural heritage, this villa masterfully integrates traditional ornate arched jali patterns with contemporary comfort. The warm desert tones create an atmosphere of timeless elegance while modern amenities ensure a luxurious living experience. Every archway and pattern tells a story of cultural reverence and artistic excellence.',
    features: ['Islamic Architecture', 'Arched Jali Patterns', 'Desert Tones', 'Cultural Heritage', 'Ornate Detailing'],
  },
  {
    id: 'ammar-residence',
    title: 'Ammar Residence',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgAmmarEvening,
    location: 'Vaso, India',
    year: '2024',
    area: '3,200 sq ft',
    description: 'A warm contemporary home with wooden accents, jali screens, and beautiful evening ambience.',
    details: 'The Ammar Residence embodies warmth and sophistication in contemporary residential design. Rich wooden accents frame the living spaces while intricate jali screens filter light beautifully. The evening ambience, carefully crafted through landscape lighting and architectural illumination, transforms this home into a beacon of modern living.',
    features: ['Wooden Accents', 'Jali Screens', 'Evening Ambience', 'Landscape Lighting', 'Contemporary Warmth'],
  },
  {
    id: 'sohel-house',
    title: 'Sohel House',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgSohelHouse,
    location: 'Nadiad, India',
    year: '2023',
    area: '6,000 sq ft',
    description: 'A grand residential project with cantilevered wooden ceilings, stone cladding, and expansive glazing.',
    details: 'Sohel House is a grand statement in residential architecture. The dramatic cantilevered wooden ceilings create a sense of floating luxury, while natural stone cladding grounds the structure in its environment. Expansive glazing dissolves the boundary between interior and exterior, bringing the landscape into every living space.',
    features: ['Cantilevered Ceilings', 'Stone Cladding', 'Expansive Glazing', 'Grand Scale', 'Indoor-Outdoor Flow'],
  },
  {
    id: 'ammar-residence-night',
    title: 'Ammar Residence - Night View',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgAmmarNight,
    location: 'Vaso, India',
    year: '2024',
    area: '3,200 sq ft',
    description: 'The dramatic night perspective showcasing accent lighting, textured walls, and jali pattern detailing.',
    details: 'Under the night sky, the Ammar Residence reveals another dimension of its design language. Accent lighting dramatizes the textured walls and jali patterns, creating a mesmerizing interplay of light and shadow. This night perspective demonstrates how thoughtful lighting design can transform architecture into art.',
    features: ['Accent Lighting', 'Textured Walls', 'Night Aesthetics', 'Shadow Play', 'Architectural Lighting'],
  },
  {
    id: 'compact-modern-dwelling',
    title: 'Compact Modern Dwelling',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgCompactNight,
    location: 'Nadiad, India',
    year: '2024',
    area: '2,400 sq ft',
    description: 'A compact yet elegant home design with warm wooden cladding and ambient uplighting for a cozy night appeal.',
    details: 'Proving that luxury knows no size constraints, this compact modern dwelling maximizes every square foot with intelligent design. Warm wooden cladding gives the exterior a welcoming character, while ambient uplighting creates a dramatic nighttime presence. Smart space planning ensures that every area serves multiple purposes without compromising comfort.',
    features: ['Compact Design', 'Wooden Cladding', 'Ambient Uplighting', 'Smart Space Planning', 'Cozy Appeal'],
  },
  {
    id: 'contemporary-residence-street',
    title: 'Contemporary Residence - Street View',
    category: 'Architecture',
    tags: ['Architecture'],
    image: imgContemporaryAngle,
    location: 'Nadiad, India',
    year: '2023',
    area: '3,800 sq ft',
    description: 'The full street elevation revealing the layered massing and material harmony of this urban residence.',
    details: 'This street-level perspective reveals the full architectural composition of the contemporary residence. The layered massing creates visual depth and interest, while the harmonious use of materials — wood, stone, and glass — demonstrates a masterful understanding of proportion and texture. The design responds thoughtfully to its urban context while maintaining a distinct identity.',
    features: ['Layered Massing', 'Material Harmony', 'Urban Context', 'Street Presence', 'Proportional Design'],
  },
];

export default projects;
